
export default class mobileMenu
{
    constructor()
    {
        var progress = false;
        var $menu = $('.mobile-menu-wrapper');
        var $open = $('.mobile-nav-icon');
        var $close = $('.mobile-menu-close-btn');
        var $lastLink = $menu.find('ul:not(.mobile-sub-menu) > li:last-of-type').last().children();
        var $content = $('.content-wrapper');

        setHome($menu);
        toggleMenu($menu, $open, $close, $content);
        lastLinkTabbing($lastLink);
        closeButtonTabbing($close);

        function closeButtonTabbing ($close) {
            $close.keydown(function (e) {
                if (e.shiftKey && e.keyCode === 9) {
                    e.preventDefault();
                    $lastLink.focus();
                }
            })
        }

        function lastLinkTabbing ($lastLink) {
            $lastLink.keydown(function (e) {
                if (!e.shiftKey && e.keyCode === 9) {
                    e.preventDefault();
                    $close.focus();
                }
            });
        }

        function setHome($menu){
            $menu.find('.mobile-icon').first().removeClass('fa-link');
            $menu.find('.mobile-icon').first().addClass('fa-home');
        }

        function toggleMenu($menu, $open, $close, $content){
            openMenu($open, $menu, $content);
            closeMenu($close, $menu, $content);
            openSubmenu($menu);
            checkSizeChange($menu, $content);

            function checkSizeChange($menu, $content) {
                $(window).resize(function () {
                    if($('.mobile-menu-dark-screen').hasClass('mobile-menu-open')) {
                        if (Modernizr.mq("screen and (min-width:1023px)")) {
                            action_close($menu, $content);
                        }
                    }
                });
            }

            function openMenu($open, $menu, $content){
                $open.click(function(e) {
                    if (!progress) {
                        if(!$('.mobile-menu-wrapper').hasClass('mobile-menu-wrapper-open')){
                            action_open($menu, $content);
                        }
                    }
                });
            }

            function closeMenu($close, $menu, $content){
                $('.mobile-menu-dark-screen').click(function(e) {
                    e.preventDefault();
                    if (e.type == "click" || (e.type == "keydown" && e.which == '13') && !progress) {
                        if($('.mobile-menu-dark-screen').hasClass('mobile-menu-open')){
                            action_close($menu, $content);
                        }
                    }
                });

                $close.click(function(e) {
                    e.preventDefault();
                    if (e.type == "click" || (e.type == "keydown" && e.which == '13') && !progress) {
                        if($('.mobile-menu-wrapper').hasClass('mobile-menu-wrapper-open')){
                            action_close($menu, $content);
                        }
                    }
                });
            }

            function openSubmenu($menu){
                $menu.find('.mobile-sub-trigger').on('click keydown', function(e) {
                    e.stopPropagation();
                    let $submenu = $(this).siblings('.mobile-sub-menu');
                    if (e.type == "click" || (e.type == "keydown" && e.which == '13') && !progress) {
                        e.preventDefault();
                        if(!$submenu.hasClass('sub-expand')){
                            $(this).attr('aria-expanded', true);
                            $submenu.addClass('sub-expand');
                            $submenu.siblings('.mobile-sub-trigger').find('.mobile-icon').addClass('sub-expand');
                        } else {
                            $(this).attr('aria-expanded', false);
                            $submenu.removeClass('sub-expand');
                            $submenu.siblings('.mobile-sub-trigger').find('.mobile-icon').removeClass('sub-expand');
                        }
                    }
                });
            }

            function action_close($menu, $content){
                progress = true;
                $menu.animateCss('fadeOutRightBig');
                $menu.parent().siblings('.mobile-menu-dark-screen').removeClass('mobile-menu-open');
                $close.attr('aria-expanded', false);
                $open.attr('aria-pressed', false);
                $content.attr('aria-hidden', false);
                $('body').removeClass('mobile-menu-open');
                setTimeout(function(){
                    $menu.removeClass('mobile-menu-wrapper-open');
                }, 300);

                setTimeout(function(){
                    progress = false;
                    $open.focus();
                }, 850);
            }

            function action_open($menu, $content){
                progress = true;
                $('body').addClass('mobile-menu-open');
                $menu.addClass('mobile-menu-wrapper-open');
                $menu.animateCss('fadeInRightBig');
                $menu.parent().siblings('.mobile-menu-dark-screen').addClass('mobile-menu-open');
                $close.attr('aria-expanded', true);
                $open.attr('aria-pressed', true);
                $content.attr('aria-hidden', true);
                setTimeout(function(){
                    progress = false;
                    $menu.find('ul').first().find('li > a').first().focus();
                }, 850);
            }

        }
    }
}
